import styled from '@emotion/styled';
import noavatar from './static/img/noavatar.png';
import Gravatar from 'react-gravatar';
import { css } from '@emotion/react';
import { Colors } from '@utex/ui-kit';
import { ViewType } from '../../../../types';

export function getBorderColor(view: ViewType) {
  switch (view) {
    case 'white':
      return Colors.ut.bgDefault;

    case 'black':
      return '1px solid rgba(0, 0, 0, 0.3)';

    default:
      return 'transparent';
  }
}

export const avatar = (view: ViewType, email?: string) => css`
  position: relative;
  flex-shrink: 0;
  display: flex;
  width: 8em;
  height: 8em;
  padding: 0;
  font-size: 0.5rem;
  background-image: ${!email && `url(${noavatar})`};
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 0 0 1px ${getBorderColor(view)};
  border-radius: 50%;
  box-sizing: content-box;

  ${email &&
  css`
    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.15) 0%,
          rgba(0, 0, 0, 0.15) 100%
        ),
        linear-gradient(0deg, #3187ee, #3187ee);
      border-radius: 50%;
    }
  `};
`;

export const Text = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3em;
  font-weight: 700;
  text-transform: uppercase;
  color: ${Colors.text.inverse};
`;

interface GravatarItemProps {
  email?: string;
}

export const GravatarItem = styled(Gravatar)<GravatarItemProps>`
  z-index: ${(props) => props.email && 1};
  width: 100%;
  height: 100%;
  font-size: 0;
  border-radius: 50%;
`;

export const LockerSvg = styled('svg')`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  flex-shrink: 0;
  margin: 0 !important;
  width: 1.1rem;
  height: 1.2rem;
  fill: currentColor;
`;

export const iconWarning = css`
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  z-index: 2;

  width: 1.3rem;
  height: 1.6rem;
`;
